/* eslint-disable */
export default array =>
  array.reduce((str, byte) => str + byte.toString(16).padStart(2, '0'), '');
